module.exports = __webpack_public_path__ + "static/media/revenue-color.f3a81a74.png";